const EmergencyInfoCard = () => {
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
      <div className="flex items-center gap-1.5 mb-2">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-information-line text-amber-600 text-xs"/>
        </div>
        <h4 className="text-xs font-semibold text-slate-700">긴급 이벤트 처리 기준</h4>
      </div>
      <p className="text-xs text-slate-500 leading-relaxed" style={{ wordBreak: "keep-all" }}>
        이 화면은 어르신 앱 또는 서버 규칙으로 생성된 긴급 이벤트와 lifecycle 이력을 운영자가 확인하는 화면입니다. 확인·대응·해결은 연결된 Keeper가 수행하며 관리자는 해결 사건 재개만 수행할 수 있습니다.
        표시된 위험도는 이벤트 우선순위 참고용이며 의료 진단이나 자동 판단을 의미하지 않습니다.
      </p>
    </div>);
};
export default EmergencyInfoCard;
